import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/auth/Login';
import Regist from '@/pages/auth/Regist';
import AuthorizeCb from '@/pages/auth/AuthorizeCb';
import AlreadyRegist from '@/pages/auth/AlreadyRegist';
// 首页
import Index from '@/pages/index/Index';
// 支付页面
import Payment from '@/pages/payment/Payment';
//维修员
import Repairer from '@/pages/repairer/Repairer';
import RepairerCancel from '@/pages/repairer/RepairerCancel';
import RepairerClose from '@/pages/repairer/RepairerClose';
import Stuff from '@/pages/repairer/Stuff';
// 通知
import Notice from '@/pages/notice/Notice';
import NoticeList from '@/pages/notice/NoticeList';
// 物业平台
import Property from '@/pages/property/Property';
import Propertys from '@/pages/property/Propertys';
import Zpop from '@/pages/property/Zpop';
import Shereye from '@/pages/property/Shereye';
import PropertyDetiles from '@/pages/property/Detiles';
// 商业平台
import Business from '@/pages/business/Business';
import BusinessList from '@/pages/business/List';
import Recommend from '@/pages/business/child/Recommend';
import MeetingRoom from '@/pages/business/child/MeetingRoom';
import Equipment from '@/pages/business/child/Equipment';
import RecommendInfo from '@/pages/business/child/RecommendInfo';
import EquipmentInfo from '@/pages/business/child/EquipmentInfo';
import OfficeDetalis from '@/pages/business/components/detalis/OfficeDetalis';
import OfficeAppointment from '@/pages/business/components/detalis/OfficeAppointment';

// 政务平台
import GovernmentAffairs from '@/pages/governmentAffairs/GovernmentAffairs';
import GovernmentDetiles from '@/pages/governmentAffairs/Detiles';
// 金融服务
import Finance from '@/pages/finance/Finance';
import FinanceDetalis from '@/pages/finance/components/FinanceDetalis';
// 人力资源
import HumanResource from '@/pages/humanResource/HumanResource';
import JobList from '@/pages/humanResource/components/JobList';
import ServiceList from '@/pages/humanResource/components/ServiceList';
import EduList from '@/pages/humanResource/components/EduList';
import JobDetail from '@/pages/humanResource/components/JobDetail';
import ServiceDetail from '@/pages/humanResource/components/ServiceDetail';
import EduDetail from '@/pages/humanResource/components/EduDetail';
// 园区配套
import ParkCompleteSet from '@/pages/parkCompleteSet/ParkCompleteSet';
import CampusActivities from '@/pages/parkCompleteSet/components/CampusActivities';
import ExclusiveActivities from '@/pages/parkCompleteSet/components/ExclusiveActivities';
import FoodCourt from '@/pages/parkCompleteSet/components/FoodCourt';
import ActivitiesDetalis from '@/pages/parkCompleteSet/components/detalis/ActivitiesDetalis';
import ExclusiveDetalis from '@/pages/parkCompleteSet/components/detalis/ExclusiveDetalis';
import SellerDetail from '@/pages/parkCompleteSet/components/eleme/SellerDetail';
import SubmitOrder from '@/pages/parkCompleteSet/components/eleme/SubmitOrder';
import EditAddress from '@/pages/parkCompleteSet/components/eleme/EditAddress';
import WechatPay from '@/pages/parkCompleteSet/components/eleme/WechatPay';
// 产品路演
import Production from '@/pages/production/Production';
import ProductionDetail from '@/pages/production/ProductionDetail';
// 信息交互
import Bbs from '@/pages/bbs/Bbs';
import NeedBuyList from '@/pages/bbs/components/NeedBuyList';
import BlogList from '@/pages/bbs/components/BlogList';
import Publish from '@/pages/bbs/components/Publish';
import Dkeou from '@/pages/bbs/components/Dkeou';
import Oders from '@/pages/bbs/components/Oders';
import Protocol from '@/pages/bbs/components/Protocol';
import BlogDetail from '@/pages/bbs/components/BlogDetail';
import PublishComment from '@/pages/bbs/components/PublishComment';
import NeedBuyDetalis from '@/pages/bbs/components/NeedBuyDetalis';
// 后台管理
import Backstage from '@/pages/backstage/Backstage';
import Personal from '@/pages/personal/Personal';
import UserIndex from '@/pages/personal/UserIndex';
import EditInfo from '@/pages/personal/EditInfo';
import News from '@/pages/personal/News';
import Bill from '@/pages/personal/Bill';
import Pay from '@/pages/personal/Pay';
import EditCard from '@/pages/personal/EditCard';
import OrderList from '@/pages/personal/OrderList';
import PropertyList from '@/pages/personal/Property';
import Invoice from '@/pages/personal/Invoice';
import AddInvoice from '@/pages/personal/AddInvoice';
import OrderDetail from '@/pages/personal/OrderDetail';
import RightDetail from '@/pages/personal/RightDetail';
import BillDetalis from '@/pages/personal/detalis/BillDetalis';
import PayDetalis from '@/pages/personal/detalis/PayDetalis';
import BianDetalis from '@/pages/personal/detalis/BianDetalis';

// 商城
import ShoppingMall from '@/pages/shoppingMall/ShoppingMall';
import ShoppingDetelis from '@/pages/shoppingMall/components/ShoppingDetelis';

// 二维码
import Qrcode from '@/pages/qrcode/Qrcode';
import Select from '@/pages/select/Select';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/index',
    },
    // 登录
    {
      path: '/auth/login',
      component: Login,
    },
    // 注册
    {
      path: '/auth/regist',
      component: Regist,
    },
    {
      path: '/auth/authorizeCb',
      component: AuthorizeCb,
    },
    // 已经注册
    {
      path: '/auth/already',
      component: AlreadyRegist,
    },
    // 首页
    {
      path: '/index',
      name: 'index',
      component: Index,
    },
    // 支付
    {
      path: '/payment',
      component: Payment,
    },
    // 维修员
    {
      path: '/repairer/apply/:orderId',
      component: Repairer,
    },
    {
      path: '/repairer/cancel/:orderId',
      component: RepairerCancel,
    },
    {
      path: '/repairer/close/:orderId',
      component: RepairerClose,
    },
    {
      path: '/repairer/stuff/:orderId',
      component: Stuff,
    },
    // 通知
    {
      path: '/notice/:noticeid',
      component: Notice,
    },
    {
      path: '/noticelist',
      component: NoticeList,
    },
    // 物业服务
    {
      path: '/property',
      component: Property,
    },
    {
      path: '/propertys',
      component: Propertys,
    },
    {
      path: '/Zpop',
      component: Zpop,
    },
    {
      path: '/Shereye',
      component: Shereye,
    },
    {
      path: '/propertyDetiles/:serviceId',
      component: PropertyDetiles,
    },
    // 商务服务
    {
      path: '/business',
      component: Business,
      children: [
        {
          path: '/',
          redirect: 'businessList',
        },
        {
          path: 'businessList',
          component: BusinessList,
          children: [
            {
              path: 'recommend/:serviceId',
              component: Recommend,
            },
            {
              path: 'meetingRoom/:serviceId',
              component: MeetingRoom,
            },
            {
              path: 'equipment/:serviceId',
              component: Equipment,
            },
          ],
        },
        {
          path: 'recommendInfo/:fineServiceId',
          component: RecommendInfo,
        },
        {
          path: 'EquipmentInfo/:serviceId/:facilitiesId',
          component: EquipmentInfo,
        },
        {
          path: 'officeDetalis/:roomId',
          component: OfficeDetalis,
        },
        {
          path: 'officeAppointment/:roomId',
          component: OfficeAppointment,
        },
      ]
    },
    // 政务平台
    {
      path: '/governmentAffairs',
      component: GovernmentAffairs,
    },
    {
      path: '/governmentDetiles/:serviceId',
      component: GovernmentDetiles,
    },
    // 金融服务
    {
      path: '/finance',
      component: Finance,
    },
    {
      path: '/financeDetalis/:serviceId',
      component: FinanceDetalis,
    },
    // 人力资源
    {
      path: '/humanResource',
      component: HumanResource,
      children: [
        {
          path: '/',
          component: JobList,
        },
        {
          path: 'jobList',
          component: JobList,
        },
        {
          path: 'serviceList',
          component: ServiceList,
        },
        {
          path: 'eduList',
          component: EduList,
        },
      ],
    },
    {
      path: '/humanResource/jobDetail/:id',
      component: JobDetail,
    },
    {
      path: '/humanResource/serviceDetail/:id',
      component: ServiceDetail,
    },
    {
      path: '/humanResource/eduDetail/:id',
      component: EduDetail,
    },
    //  园区配套
    {
      path: '/parkCompleteSet',
      component: ParkCompleteSet,
      children: [
        {
          path: '/',
          component: FoodCourt,
        },
        {
          path: 'campusActivities',
          component: CampusActivities,
        },
        {
          path: 'exclusiveActivities',
          component: ExclusiveActivities,
        },
        {
          path: 'foodCourt',
          component: FoodCourt,
        },
      ],
    },
    {
      path: '/activitiesDetalis/:activityId',
      component: ActivitiesDetalis,
    },
    {
      path: '/exclusiveDetalis/:exclusiveDetalisId',
      component: ExclusiveDetalis,
    },
    {
      path: '/sellerDetail/:id',
      component: SellerDetail,
    },
    {
      path: '/submitOrder',
      component: SubmitOrder,
    },
    {
      path: '/smark/pay/wechat',
      component: WechatPay,
    },
    {
      path: '/eleme/editAddress',
      component: EditAddress,
    },
    // 产品路演
    {
      path: '/production',
      component: Production,
    },
    {
      path: '/production/detail/:productionId',
      component: ProductionDetail,
    },
    // bbs
    {
      path: '/bbs',
      component: Bbs,
      children: [
        {
          path: '/',
          component: NeedBuyList,
        },
        {
          path: 'needBuyList',
          component: NeedBuyList,
        },
        {
          path: 'blogList',
          component: BlogList,
        },
      ],
    },
    {
      path: '/bbs/publish',
      component: Publish,
    },
    {
      path: '/bbs/Dkeou',
      component: Dkeou,
    },
    {
      path: '/bbs/Oders',
      component: Oders,
    },
    {
      path: '/bbs/publish/protocol',
      component: Protocol,
    },
    {
      path: '/bbs/detail/:id',
      component: BlogDetail,
    },
    {
      path: '/bbs/publishComment/:postId',
      component: PublishComment,
    },
    {
      path: '/needBuyDetalis/:needBuyDetalisId',
      component: NeedBuyDetalis,
    },
    // 后台管理
    {
      path: '/backstage',
      component: Backstage,
    },
    // 个人中心
    {
      path: '/personal',
      component: Personal,
      children: [
        {
          path: '/',
          component: UserIndex,
        },
        {
          path: 'editCard',
          component: EditCard,
        },
        {
          path: 'editInfo',
          component: EditInfo,
        },
        {
          path: 'News',
          component: News,
        },
        {
          path: 'Bill',
          component: Bill,
        },
        {
          path: 'Pay',
          component: Pay,
        },
        {
          path: 'orderList',
          component: OrderList,
        },
        {
          path: 'propertyList',
          component: PropertyList,
        },
        {
          path: 'invoice',
          component: Invoice,
        },
        {
          path: 'addinvoice',
          component: AddInvoice,
        },
        {
          path: 'modifyinvoice',
          component: AddInvoice,
        },
        {
          path: 'orderDetail',
          component: OrderDetail,
        },
        {
          path: 'rightDetail/:serviceId',
          component: RightDetail,
        },
      ],
    },
    {
      path: '/BillDetalis/:BillDetalisId',
      component: BillDetalis,
    },
    {
      path: '/PayDetalis/:PayDetalisId',
      component: PayDetalis,
    },
    {
      path: '/BianDetalis/:DetalisId/:BianDetalisId',
      component: BianDetalis,
    },
    // 商城
    {
      path: '/shoppingMall',
      component: ShoppingMall,
    },
    {
      path: '/shoppingDetelis',
      component: ShoppingDetelis,
    },
    // 二维码
    {
      path: '/qrcode/:parkId/:qrId',
      component: Qrcode,
    },
    {
      path: '/select',
      component: Select,
    }
  ],
  scrollBehavior (to, from, savedPosition) {
  // return 期望滚动到哪个的位置
  window.scrollTo(0, 0);
  },
  mode: 'history',
})



// WEBPACK FOOTER //
// ./src/router/index.js